import React from 'react';
import './Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>ApplicodeTech</h3>
              <p>Solutions technologiques innovantes pour votre succès</p>
            </div>
            <div className="footer-section">
              <h4>Liens Rapides</h4>
              <ul>
                <li><a href="/">Accueil</a></li>
                <li><a href="/about">À propos</a></li>
                <li><a href="/services">Services</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Services</h4>
              <ul>
                <li><a href="#services">Développement Web</a></li>
                <li><a href="#services">Applications Mobiles</a></li>
                <li><a href="#services">Cloud & DevOps</a></li>
                <li><a href="#services">Cybersécurité</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>Email: info@applicodetech.com</p>
              <p>Tél: +221 76 609 19 32</p>
              <p>Saint-Louis, Sénégal</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {currentYear} ApplicodeTech. Tous droits réservés.</p>
          </div>
        </div>
      </footer>
  );
}